import type { SessionExpiredRecovery } from '@core/ports/SessionExpiredRecovery';
import type { NhsAppGateway } from '@core/ports/NhsAppGateway';
import { navigateToTrustedTarget } from '@infrastructure/navigation/trustedNavigation';
import { OriginalOriginStore } from '@infrastructure/storage/OriginalOriginStore';

export class NhsAppSessionExpiredRecovery implements SessionExpiredRecovery {
  public constructor(
    private readonly nhsAppGateway: NhsAppGateway,
    private readonly originalOriginStore: OriginalOriginStore
  ) {}

  public async returnOrFallback(): Promise<void> {
    const originalOrigin = this.originalOriginStore.get() ?? this.originalOriginStore.getHome();
    if (!originalOrigin) {
      await this.nhsAppGateway.goToHomePage();
      return;
    }

    try {
      await this.nhsAppGateway.navigateToAppPage(originalOrigin.appPage, originalOrigin.browserUri);
    } catch {
      navigateToTrustedTarget(originalOrigin.browserUri, '/');
    }
  }
}
